import React from 'react';
import firebaseApi from '../../firebase/firebaseApi';
import { ProjectTrackingPage } from './ProjectTrackingPage';

export const ProjectTrackingPageWrapper = (): JSX.Element => {
	return <ProjectTrackingPage firebaseApi={firebaseApi} />;
};
